import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Subject } from 'rxjs';

@Injectable()
export class LoaderService {
  public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public navigateTo: Subject<string> = new Subject();
  public timeOut = false;
  component: Record<string, boolean> = {};

  display(value: boolean, c = 'default', delay = 200) {
    this.component[c] = value;
    if (!this.timeOut) {
      this.timeOut = true;
      setTimeout(()=> this.updateStatus(), delay);
    }
  }

  updateStatus() {
    let showLoader = false;
    for (const i in this.component) {
      if (this.component[i]) {
        showLoader = true;
        break;
      }
    }
    this.status.next(showLoader);
    this.timeOut = false
  }

  resetAll() {
    this.component = {};
    this.status.next(false);
  }
}
